// frontend/src/api/teachers.ts
import api from './axios';
import {
    Teacher,
    CreateTeacherRequest,
    UpdateTeacherRequest
} from '../types/teacher';

export async function getTeachers(): Promise<Teacher[]> {
    const res = await api.get<Teacher[]>('/teachers');
    return res.data;
}

export async function getTeacher(id: string): Promise<Teacher> {
    const res = await api.get<Teacher>(`/teachers/${id}`);
    return res.data;
}

export async function createTeacher(
    data: CreateTeacherRequest
): Promise<Teacher> {
    const res = await api.post<Teacher>('/teachers', data);
    return res.data;
}

export async function updateTeacher(
    id: string,
    data: UpdateTeacherRequest
): Promise<Teacher> {
    const res = await api.patch<Teacher>(`/teachers/${id}`, data);
    return res.data;
}

export async function deleteTeacher(id: string): Promise<void> {
    await api.delete(`/teachers/${id}`);
}
